export var SCHOOL_NOT_LISTED_ID = 'a5c4cb9d-4cb6-47e3-9bea-97464743a839';
export var COURSE_NOT_LISTED_ID = 'a874cb9d-4cb6-47e3-9bea-849157430976';
export var SCHOOL_NOT_FOUND_SELECTED_VALUE = 'Enter school below';
export var COURSE_NOT_FOUND_SELECTED_VALUE = 'Enter course below';
export var SCHOOL_NOT_LISTED_TEXT = 'For the best study experience, enter your school →';
export var COURSE_NOT_LISTED_TEXT = "No exact match. Let's try another way →";
export var MANUAL_INPUT_CHAR_LIMIT = 1000;
export var ERROR_MESSAGES = {
  MANUAL_SCHOOL_INPUT_SIZE: 'School name should not exceed 1000 characters',
  MANUAL_COURSE_INPUT_SIZE: 'Course name should not exceed 1000 characters',
  NO_SCHOOL_SELECTED: 'Enter your school',
  NO_COURSE_SELECTED: 'Enter your course',
  COURSE_ALREADY_ADDED: 'That course was already added. Add another.',
  RIO_ERROR_MESSAGE: 'error in add a course flow'
};
export var RIO_SCHOOL_NOT_LISTED_VALUE = 'school not found';
export var RIO_COURSE_NOT_LISTED_VALUE = 'course instance not found';
export var RIO_COURSE_LISTED_VALUE = 'course instance';
export var RIO_COURSE_CLASSIFICATION_LISTED_VALUE = 'course classification variant';
export var SEARCH_ROWS = 10;
export var COURSE_SUGGESSTION_LIMIT = 5;
export var TEAM_NAME = 'UD';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-plat-ui/utils/dist/esm/constants.js
// module id = 5775
// module chunks = 11